"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Supported AIOS message types:
 * RECEPTION
 * UTTERANCE
 * BUTTON
 * SUBMIT
 * SUGGESTION
 */
var MessageType;
(function (MessageType) {
    MessageType["RECEPTION"] = "reception";
    MessageType["AUDIO"] = "audio";
    MessageType["UTTERANCE"] = "utterance";
    MessageType["BUTTON"] = "button";
    MessageType["SUBMIT"] = "submit";
    MessageType["SUGGESTION"] = "suggestion";
    MessageType["RATING"] = "rating";
})(MessageType = exports.MessageType || (exports.MessageType = {}));
